import { render, staticRenderFns } from "./DataOrganismDicomCaseVersionMolecule.vue?vue&type=template&id=e3f438dc&"
import script from "./DataOrganismDicomCaseVersionMolecule.vue?vue&type=script&lang=js&"
export * from "./DataOrganismDicomCaseVersionMolecule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports